import { pipe } from 'fp-ts/function';
import { filter } from 'fp-ts/Array';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { CompanyAccountClassifications } from '@mews-commander/legacy-data-structures';
import { useCreateSelectFieldOptions } from '@mews-commander/form';
import { mapValue } from '@mews-commander/utils';
import { InputField, SelectField } from '@mews-commander/legacy-form';
import { ResponsiveTwoColumnsFormFields } from '@mews-commander/ui';
import { SourceSelectField } from './SourceSelectField';

const contactPersonProps = {
    name: 'contactPerson',
    label: <LocalizedText textKey={TextKey.ContactName} />,
};

const contactProps = {
    name: 'contact',
    label: <LocalizedText textKey={TextKey.ContactInfo} />,
};

const sourceIdProps = {
    name: 'sourceId',
    label: <LocalizedText textKey={TextKey.Channel} />,
    showEmptyValue: true,
};

const iataProps = {
    name: 'iata',
    label: <LocalizedText textKey={TextKey.Iata} />,
};

const classificationsProps = {
    name: 'classifications',
    label: <LocalizedText textKey={TextKey.Classification} />,
    showEmptyValue: true,
    multiselect: true,
    enumClass: CompanyAccountClassifications,
    useNameAsValue: true,
};

export const CompanyAdditionalInfoFields = () => {
    const germanB2BBillingEnabled = useFeatureFlag(FeatureFlag.germanB2bBillingEnabled);

    const selectFieldOptions = pipe(
        CompanyAccountClassifications.enumValues,
        mapValue,
        filter(
            (classification) =>
                germanB2BBillingEnabled || classification !== CompanyAccountClassifications.GovernmentEntity.name
        ),
        useCreateSelectFieldOptions(
            CompanyAccountClassifications.enumValues.map((value) => value.value),
            [],
            'CompanyAccountClassifications'
        )
    );
    return (
        <>
            <InputField {...contactPersonProps} />
            <SelectField {...classificationsProps} options={selectFieldOptions} />
            <InputField {...contactProps} />
            <ResponsiveTwoColumnsFormFields>
                <SourceSelectField {...sourceIdProps} />
                <InputField {...iataProps} />
            </ResponsiveTwoColumnsFormFields>
        </>
    );
};
